import React from 'react'
import { Grid, makeStyles, Paper, Typography } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { toast } from 'utils/notify'

import { updateConferenceById } from 'store/conference'
import AvatarPicker from 'components/AvatarPicker'
import { Collection } from 'constants/index'

const ImgKeys = {
  confMap: 'confMap',
  confSplashScreenImg: 'confSplashScreenImg',
  boothMap: 'boothMap'
}

const ConferenceImagesForm = ({ conference }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const handleUpload = (key) => async (name) => {
    if (!conference?.id) {
      toast.error('Conference ID is missing. Reload and try again.')
      return
    }

    const modifiedConf = { ...conference }
    delete modifiedConf['id']

    if (key === ImgKeys.confMap) {
      modifiedConf[ImgKeys.confMap] = name
    } else if (key === ImgKeys.confSplashScreenImg) {
      modifiedConf[ImgKeys.confSplashScreenImg] = name
    } else if (key === ImgKeys.boothMap) {
      modifiedConf[ImgKeys.boothMap] = name
    }

    try {
      // setLoading(true)
      await dispatch(updateConferenceById(conference.id, modifiedConf))
      toast.success('Image updated.')
    } catch (error) {
      toast.error('Could not update image.')
      console.error(error)
    } finally {
      // setLoading(false)
    }
  }

  const handleDelete = async (key) => {
    if (!conference?.id) {
      toast.error('Conference ID is missing. Reload and try again.')
      return
    }

    const modifiedConf = { ...conference }
    delete modifiedConf['id']

    if (key === ImgKeys.confMap) {
      modifiedConf[ImgKeys.confMap] = null
    } else if (key === ImgKeys.confSplashScreenImg) {
      modifiedConf[ImgKeys.confSplashScreenImg] = null
    } else if (key === ImgKeys.boothMap) {
      modifiedConf[ImgKeys.boothMap] = null
    }

    try {
      await dispatch(updateConferenceById(conference.id, modifiedConf))
      toast.success('Image removed.')
    } catch (error) {
      toast.error('Could not remove image.')
      console.error(error)
    }
  }

  return (
    <Paper className={classes.section}>
      <Typography variant="h6" color="secondary" className={classes.sectionTitle}>
        Conference Images
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AvatarPicker
            title="Location Map"
            subTitle="Allowed Format: PNG/JPG"
            path={Collection.CONFERENCES}
            onUpload={(name) => handleUpload(ImgKeys.confMap)(name)}
            onDelete={() => handleDelete(ImgKeys.confMap)}
            imageName={conference?.id ? conference?.confMap : null}
            conferenceId={conference?.id || null}
            firsTimeUpload={false}
          />
        </Grid>
        <Grid item xs={12}>
          <AvatarPicker
            title="Splash Screen"
            subTitle="Allowed Format: PNG/JPG"
            path={Collection.CONFERENCES}
            onUpload={(name) => handleUpload(ImgKeys.confSplashScreenImg)(name)}
            onDelete={() => handleDelete(ImgKeys.confSplashScreenImg)}
            imageName={conference?.id ? conference?.confSplashScreenImg : null}
            conferenceId={conference?.id || null}
            firsTimeUpload={false}
          />
        </Grid>
        <Grid item xs={12}>
          <AvatarPicker
            title="Booth Map"
            subTitle="Allowed Format: PNG/JPG"
            path={Collection.CONFERENCES}
            onUpload={(name) => handleUpload(ImgKeys.boothMap)(name)}
            onDelete={() => handleDelete(ImgKeys.boothMap)}
            imageName={conference?.id ? conference?.boothMap : null}
            conferenceId={conference?.id || null}
            firsTimeUpload={false}
          />
        </Grid>
      </Grid>
    </Paper>
  )
}

const useStyles = makeStyles({
  section: {
    marginBottom: '24px',
    padding: '18px 24px',
    borderRadius: '8px',
    boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
    backgroundColor: '#ffffff'
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: '20px',
    borderBottom: '1px solid #eee',
    paddingBottom: '10px'
  }
})

export default ConferenceImagesForm
